<template>
  <div class="bottom">
    <Bar />
    <button class="skip-video" v-show="showSkip" @click="goForward">
      Skip
    </button>
    <LinearButton v-show="!showSkip" back @click="goBack"></LinearButton>
    <LinearButton @click="goForward"></LinearButton>
  </div>
</template>

<script>
//import axios from "axios";
import Bar from "@/components/svg/nav-bottom_desktop.vue";
import LinearButton from "@/patterns/LinearButton.vue";
export default {
  name: "Bottom",
  components: { Bar, LinearButton },
  data: () => ({ showSkip: true }),
  beforeDestroy() {
    window.removeEventListener("keydown", this.keyboardNavigation);
  },
  mounted() {
    window.addEventListener("keydown", this.keyboardNavigation);
    if ("" !== this.$router.currentRoute.path) {
      this.showSkip = false;
    }
  },
  watch: {
    $route(to) {
      this.showSkip = false;
      if (to.path === "/") {
        this.showSkip = true;
      }
      this.preloadNextRoute();
    },
  },
  methods: {
    keyboardNavigation(e) {
      const directions = {
        ArrowLeft: this.goBack,
        ArrowRight: this.goForward,
      };
      if (directions[e.key] !== undefined) {
        directions[e.key]();
      }
    },
    goBack() {
      const currentIndex = this.getCurrentPath();
      if (currentIndex == 0) {
        //at beginning
        return;
      }
      this.$router.push(this.$router.options.routes[currentIndex - 1]);
    },
    goForward() {
      const currentIndex = this.getCurrentPath();
      if (currentIndex == this.$router.options.routes.length - 1) {
        //at end
        return;
      }
      this.$router.push(this.$router.options.routes[currentIndex + 1]);
    },
    preloadNextRoute() {
      //const currentIndex = this.getCurrentPath();
      //if (currentIndex == this.$router.options.routes.length - 1) {
        //at end
        //return;
      //}
      //const path = this.$router.options.routes[currentIndex + 1].path;
      //axios.get(path);
    },
    getCurrentPath() {
      let currentIndex = 0;
      for (let index = 0; index < this.$router.options.routes.length; index++) {
        const element = this.$router.options.routes[index];
        if (element.path === this.$router.currentRoute.path) {
          currentIndex = index;
          break;
        }
      }
      return currentIndex;
    },
  },
};
</script>


<style lang="scss" scoped>
button {
  z-index: 1;
}
.skip-video {
  color: #ffffff;
  font-family: "Gotham";
  font-size: 1em;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 0.9em;
  text-transform: uppercase;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  outline: none;
  border: none;
  padding: 0;
  padding-right: 20px;
  height: 65px;
  pointer-events: all;
  cursor: pointer;  
}
.bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 105px;
  text-align: right;
  pointer-events: none;
  svg {
    position: absolute;
    right: 0;
    bottom: 0;    
    pointer-events: none;
  }  
}
</style>
